import { Path, PathValue } from '@/types';
export function _get(object: any, path: string, defaultValue?: string) {
  return path.split('.').reduce((o, p) => (o ? o[p] : defaultValue), object);
}

export const getValue = <T, P extends Path<T>>(
  source: T,
  key: P,
  defaultValue: any = ''
): PathValue<T, P> => {
  const arrKeys = key.split('.') as string[];
  const firstKey = arrKeys.shift() || defaultValue;
  const newSource: any = source[firstKey as keyof typeof source];

  if (arrKeys.length > 0) {
    return getValue(newSource, arrKeys.join('.') as Path<any>);
  }

  return newSource;
};
